// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'
import keycode from 'keycode'

// Internal Dependencies:
import Badge from 'components/Badge/Badge'

// Redux:
import { showBadgeAwardModal } from 'actions/site'

class BadgeAwardModal extends React.Component {
	componentDidMount() {
		document.addEventListener( 'mousedown', this.handleClickOutside )
		document.addEventListener( 'keydown', this.handleKeyPress )
	}

	componentWillUnmount() {
		document.removeEventListener( 'mousedown', this.handleClickOutside )
		document.removeEventListener( 'keydown', this.handleKeyPress )
	}

	handleClickOutside = ( e ) => {
		if ( this.outside == e.target ) {
			this.handleClose()
		}
	}

	handleKeyPress = ( e ) => {
		if ( 'esc' == keycode( e ) ) {
			this.handleClose()
		}
	}

	handleClose = () => {
		this.props.dispatch( showBadgeAwardModal( false ) )
	}

	render() {
		const { showBadgeAwardModal, rewindMaxHours, futureFastForwardMaxHours } = this.props
		const badgeId = showBadgeAwardModal
		let text1, text2, text3,
			rewindText, fastForwardText

		if ( ! this.props.showBadgeAwardModal ) {
			return null
		}

		rewindText = rewindMaxHours < 24 ? `${rewindMaxHours} hours` : rewindMaxHours == 24 ? '1 day' : `${rewindMaxHours / 24} days`
		fastForwardText = futureFastForwardMaxHours < 24 ? `${futureFastForwardMaxHours} hours` : `${futureFastForwardMaxHours / 24} days`

		text2 = `As a thank you for your support, you have just earned another&nbsp;badge!`
		text3 = `You can now listen up to ${rewindText} in the past, and ${fastForwardText} into the&nbsp;future.`

		switch ( badgeId ) {
			case 'account':
				text1 = `You've created a Faith FM account! Welcome!`
				break

			case 'listen_3_hours':
				text1 = `You've listened to Faith FM online for a total of 3 hours! That's&nbsp;great!`
				break

			case 'listen_25_hours':
				text1 = `You've listened to Faith FM online for a total of 25 hours! That's&nbsp;superb!`
				break

			case 'listen_100_hours':
				text1 = `You've listened to Faith FM online for a total of 100 hours! That's&nbsp;amazing!`
				break

			case 'record_votd':
				text1 = `You've recorded your first Verse of the Day!`
				break

			case 'donate':
				text1 = `You've made your first donation!`
				break

			case 'donate_recurring':
				text1 = `You're a monthly supporter!`
				break
		}

		return (
			<div className="badge-award-modal" ref={ ( e ) => { this.outside = e } } tabIndex="0">
				<div className="-inner">
					<Badge badgeId={ badgeId } />

					<h4>You have a new badge!</h4>

					<div className="-text">
						<h5 dangerouslySetInnerHTML={ { __html: text1 } } />

						<p dangerouslySetInnerHTML={ { __html: text2 } } />
						<p dangerouslySetInnerHTML={ { __html: text3 } } />
					</div>

					<div className="-actions">
						<div className="button" onClick={ this.handleClose }>Close</div>
					</div>
				</div>
			</div>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {
		showBadgeAwardModal: state.site.showBadgeAwardModal,
		rewindMaxHours: state.schedule.rewindMaxHours,
		futureFastForwardMaxHours: state.schedule.futureFastForwardMaxHours
	}
}

export default connect( mapStateToProps )( BadgeAwardModal )
